import React, { useEffect, useState } from 'react';
import { ScrollText, UserCog, ShieldCheck, Wallet, Store, Mail, FolderOpen, Sprout, Database } from 'lucide-react';
import { adminGetAudit } from '../../lib/api';

const GROUP_META = {
  investor: { icon: UserCog, cls: 'bg-farmway-gold/15 text-farmway-gold' },
  kyc: { icon: ShieldCheck, cls: 'bg-farmway-leaf/15 text-farmway-leaf-bright' },
  holding: { icon: Wallet, cls: 'bg-sky-400/15 text-sky-300' },
  market: { icon: Store, cls: 'bg-purple-400/15 text-purple-300' },
  statements: { icon: Mail, cls: 'bg-orange-400/15 text-orange-300' },
  document: { icon: FolderOpen, cls: 'bg-farmway-leaf/15 text-farmway-leaf-bright' },
  project: { icon: Sprout, cls: 'bg-farmway-gold/15 text-farmway-gold' },
  demo: { icon: Database, cls: 'bg-white/10 text-farmway-cream/70' },
};

const fmtTime = (v) => {
  const d = new Date(v);
  return `${d.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })} · ${d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}`;
};

export default function AuditTab() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminGetAudit()
      .then(setEntries)
      .catch((e) => console.error('Failed to load audit log', e))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <div className="mb-4 flex items-center gap-3 rounded-2xl border border-white/10 bg-farmway-green-mid/40 p-5">
        <ScrollText className="h-5 w-5 shrink-0 text-farmway-gold" />
        <p className="text-sm text-farmway-cream/70">
          Every admin action is recorded here automatically: onboarding, KYC decisions, holdings changes, settlements, statements and more. Entries cannot be edited or deleted.
        </p>
      </div>
      <div data-testid="audit-list" className="overflow-hidden rounded-2xl border border-white/10">
        {loading ? (
          <p className="px-6 py-8 text-farmway-cream/50">Loading…</p>
        ) : entries.length === 0 ? (
          <p className="px-6 py-8 text-farmway-cream/50">No admin actions recorded yet.</p>
        ) : entries.map((e) => {
          const meta = GROUP_META[e.action?.split('.')[0]] || GROUP_META.demo;
          const Icon = meta.icon;
          return (
            <div key={e.id} className="flex items-start gap-4 border-t border-white/10 px-6 py-4 first:border-t-0">
              <span className={`mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-lg ${meta.cls}`}><Icon className="h-4 w-4" /></span>
              <div className="min-w-0 flex-1">
                <p className="flex flex-wrap items-center gap-2 text-sm font-medium text-farmway-cream">
                  {e.target || e.action}
                  <span className="rounded-full bg-white/10 px-2 py-0.5 font-mono text-[10px] tracking-wide text-farmway-cream/60">{e.action}</span>
                </p>
                {e.details && <p className="mt-0.5 text-xs text-farmway-cream/55">{e.details}</p>}
                <p className="mt-0.5 text-[11px] text-farmway-cream/40">{fmtTime(e.created_at)} · {e.adminEmail}</p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
